import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, mergeProps as _mergeProps, createSlots as _createSlots, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3c2b8f26"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "top-carousel",
  id: "carousel1"
}
const _hoisted_2 = ["href"]
const _hoisted_3 = ["src", "alt"]
const _hoisted_4 = ["innerHTML"]
const _hoisted_5 = ["src", "alt"]
const _hoisted_6 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Slide = _resolveComponent("Slide")!
  const _component_Navigation = _resolveComponent("Navigation")!
  const _component_Pagination = _resolveComponent("Pagination")!
  const _component_Carousel = _resolveComponent("Carousel")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.slides?.length)
      ? (_openBlock(), _createBlock(_component_Carousel, _mergeProps({
          key: 0,
          autoplay: _ctx.slides?.length > 1 ? _ctx.rotation : 0,
          "wrap-around": true
        }, _ctx.settings), _createSlots({
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.slides, (slide) => {
              return (_openBlock(), _createBlock(_component_Slide, {
                key: slide.id,
                class: _normalizeClass((slide?.textAlignment == 'top') ? 'reduce-height' : '')
              }, {
                default: _withCtx(() => [
                  (slide?.url != null)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        _createElementVNode("a", {
                          href: slide?.url,
                          target: "_blank",
                          onNavigate: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.$navigate && _ctx.$navigate(...args)))
                        }, [
                          _createElementVNode("img", {
                            class: "banner carousel__item",
                            src: slide?.image?.link,
                            alt: slide?.image?.name
                          }, null, 8, _hoisted_3)
                        ], 40, _hoisted_2),
                        (slide?.body)
                          ? (_openBlock(), _createElementBlock("div", {
                              key: 0,
                              class: _normalizeClass(["banner carousel__item__content", slide?.textAlignment]),
                              innerHTML: slide?.body
                            }, null, 10, _hoisted_4))
                          : _createCommentVNode("", true)
                      ], 64))
                    : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                        _createElementVNode("img", {
                          class: "banner carousel__item",
                          src: slide?.image?.link,
                          alt: slide?.image?.name
                        }, null, 8, _hoisted_5),
                        (slide?.body)
                          ? (_openBlock(), _createElementBlock("div", {
                              key: 0,
                              class: _normalizeClass(["banner carousel__item__content", slide?.textAlignment]),
                              innerHTML: slide?.body
                            }, null, 10, _hoisted_6))
                          : _createCommentVNode("", true)
                      ], 64))
                ]),
                _: 2
              }, 1032, ["class"]))
            }), 128))
          ]),
          _: 2
        }, [
          (_ctx.slides?.length !== 1)
            ? {
                name: "addons",
                fn: _withCtx(() => [
                  _createVNode(_component_Navigation),
                  _createVNode(_component_Pagination)
                ]),
                key: "0"
              }
            : undefined
        ]), 1040, ["autoplay"]))
      : _createCommentVNode("", true)
  ]))
}